
    import has from 'lodash/has';
    import numeral from 'numeral';
    import { mapState, mapActions } from 'vuex';
    import PayBandMenu from '@/components/Utils/PayBandMenu';
    import C1Dropdown from '@/C1Components/C1Dropdown';

    export default {
        name: 'SeekerPayBand',

        components: {
            PayBandMenu,
            C1Dropdown,
        },

        props: {
            hideLabel: {
                type: Boolean,
                default: false,
            },

            payBandMenuCentered: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                payType: 'Annually',
                minPayBand: {},
                payBandAnnually: [],
                payBandHourly: [],
            };
        },

        computed: {
            ...mapState({
                $_me: state => state.me.user,
            }),

            payBandMenuClass() {
                return [
                    'pay-band',
                    this.getPayBandMenuGroupInfoClass,
                    this.getPayBandMenuCenteredClass,
                ];
            },

            getPayBandMenuGroupInfoClass() {
                return !this.hideLabel ? 'form-group-info' : '';
            },

            getPayBandMenuCenteredClass() {
                return this.payBandMenuCentered ? 'is-centered' : '';
            },

            payBandAnnuallyFiltered() {
                return this.payBandAnnually.map((o) => {
                    o.label = o.label ? o.label : `$ ${numeral(o.value).format('0,0')}`;

                    return o;
                });
            },

            payBandHourlyFiltered() {
                return this.payBandHourly.map((o) => {
                    o.label = o.label ? o.label : `$ ${numeral(o.value).format('0,0')}`;

                    return o;
                });
            },
        },

        created() {
            this.minPayBand = has(this.$_me, 'minPayBand.id') ? this.$_me.minPayBand : {};
            this.payType = has(this.$_me, 'minPayBand.pay_type_id') && this.$_me.minPayBand.pay_type_id === 2 ? 'Hourly' : 'Annually';
            this.getAnnualSalary();
            this.getHourlyRate();
        },

        methods: {
            ...mapActions('me', {
                $_updateMyDetails: 'updateMyDetails',
            }),

            ...mapActions('payType', {
                $_getAnnualSalary: 'getAnnualSalary',
                $_getHourlyRate: 'getHourlyRate',
            }),

            getAnnualSalary() {
                this.$_getAnnualSalary().then((response) => {
                    this.payBandAnnually = response.data;
                });
            },

            getHourlyRate() {
                this.$_getHourlyRate().then((response) => {
                    this.payBandHourly = response.data;
                });
            },

            onPayTypeSelect() {
                this.minPayBand = {};
            },

            updateMinPayBand() {
                const data = {
                    min_pay_band_id: this.minPayBand.id ? this.minPayBand.id : '',
                };

                this.$emit('loading', true);
                this.$_updateMyDetails(data).finally(() => {
                    this.$emit('loading', false);
                });
            },
        },
    };
